<div class="item-thumbnail" 
    [ngStyle]="{
        'border-style': showFrame ? 'solid' : 'none',
        'aspect-ratio': square ? '1/1' : '2/3'
    }">
    
  <img-with-placeholder [placeholder]="'/picture_placeholder_4.webp' | assetUrl" [priority]="priority">
    <img 
        #image
        fullSizedImage
        (error)="fallbackToFull()"
        (load)="checkIfPortrait()"
        [ngStyle]="{
            'width': '100%', 
            'height': '100%', 
            'object-fit': isPortrait ? 'cover' : 'contain'
        }"
        [src]="pictureURL ? pictureURL : ('/picture_placeholder_4.webp' | assetUrl)"/>
  </img-with-placeholder>
  
</div>